import React from 'react'

import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import { usePdfOptionsForm } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'

const DocumentHeader = () => {
  const { headerImage } = usePdfOptionsForm()

  if (!headerImage || !headerImage.length) return <></>

  return (
    <div>
      <Separator weight={4} />
      <Image src={headerImage[0].src} maxHeight={headerImage[0].height} ignoreFixedSize={true} />
      <Separator weight={4} />
    </div>
  )
}

export default DocumentHeader
